import { render, staticRenderFns } from "./Gupshup.vue?vue&type=template&id=3cf74020&scoped=true&"
import script from "./Gupshup.vue?vue&type=script&lang=js&"
export * from "./Gupshup.vue?vue&type=script&lang=js&"
import style0 from "./Gupshup.vue?vue&type=style&index=0&id=3cf74020&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf74020",
  null
  
)

export default component.exports